import { render } from "./CustomerAccountDetailModal.vue?vue&type=template&id=7b21a2c1"
import script from "./CustomerAccountDetailModal.vue?vue&type=script&lang=js"
export * from "./CustomerAccountDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Customers/CustomerAccountDetailModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b21a2c1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b21a2c1', __exports__)) {
    api.reload('7b21a2c1', __exports__)
  }
  
  module.hot.accept("./CustomerAccountDetailModal.vue?vue&type=template&id=7b21a2c1", () => {
    api.rerender('7b21a2c1', render)
  })

}


export default __exports__